import React from 'react';
import SEO from '../components/SEO';
import './StaticPages.css';

function AboutPage() {
  return (
    <main className="static-page">
      <SEO 
        title="About E Media Forum - Entertainment Industry News"
        description="Learn about E Media Forum, your trusted source for entertainment industry news, film coverage, and television updates."
      />
      
      <div className="page-header">
        <h1>About E Media Forum</h1>
      </div>
      
      <div className="page-content">
        <section className="content-section">
          <h2>Our Mission</h2>
          <p>
            E Media Forum is dedicated to delivering comprehensive coverage of the entertainment industry. 
            We provide timely, accurate, and insightful reporting on film, television, awards, festivals, 
            and industry developments that shape the world of entertainment.
          </p>
        </section>
        
        <section className="content-section">
          <h2>What We Cover</h2>
          <div className="coverage-grid">
            <div className="coverage-item">
              <h3>Film Industry</h3>
              <p>Breaking news, box office reports, production updates, and exclusive interviews from the world of cinema.</p>
            </div>
            <div className="coverage-item">
              <h3>Television</h3>
              <p>Series premieres, streaming platform updates, industry trends, and behind-the-scenes coverage.</p>
            </div>
            <div className="coverage-item">
              <h3>Awards Season</h3>
              <p>Complete coverage of major award ceremonies, nominations, predictions, and industry recognition.</p>
            </div>
            <div className="coverage-item">
              <h3>Film Festivals</h3>
              <p>On-ground reporting from major film festivals worldwide, including premieres and industry events.</p>
            </div>
          </div>
        </section>
        
        <section className="content-section">
          <h2>Our Commitment</h2>
          <p>
            We are committed to maintaining the highest standards of journalism while providing our readers 
            with engaging, informative content. Our team of experienced entertainment journalists brings 
            you the stories that matter most in the rapidly evolving entertainment landscape.
          </p>
          
          <p>
            E Media Forum serves as a bridge between industry professionals and entertainment enthusiasts, 
            offering insights that inform, educate, and inspire our diverse readership.
          </p>
        </section>
      </div>
    </main>
  );
}

export default AboutPage;